/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Copy_TextInputs */

const en_context_menu_copy_text = /** @type {(inputs: Context_Menu_Copy_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy Text`)
};

const fr_context_menu_copy_text = /** @type {(inputs: Context_Menu_Copy_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier le texte`)
};

const de_context_menu_copy_text = /** @type {(inputs: Context_Menu_Copy_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text kopieren`)
};

const it_context_menu_copy_text = /** @type {(inputs: Context_Menu_Copy_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia testo`)
};

const ru_context_menu_copy_text = /** @type {(inputs: Context_Menu_Copy_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировать текст`)
};

const es_context_menu_copy_text = /** @type {(inputs: Context_Menu_Copy_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar texto`)
};

const zh_cn2_context_menu_copy_text = /** @type {(inputs: Context_Menu_Copy_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制文本`)
};

const ja_context_menu_copy_text = /** @type {(inputs: Context_Menu_Copy_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストをコピー`)
};

const hi_context_menu_copy_text = /** @type {(inputs: Context_Menu_Copy_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेक्स्ट कॉपी करें`)
};

const pt_pt2_context_menu_copy_text = /** @type {(inputs: Context_Menu_Copy_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar texto`)
};

/**
* | output |
* | --- |
* | "Copy Text" |
*
* @param {Context_Menu_Copy_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_copy_text = /** @type {((inputs?: Context_Menu_Copy_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Copy_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_copy_text(inputs)
	if (locale === "de") return de_context_menu_copy_text(inputs)
	if (locale === "it") return it_context_menu_copy_text(inputs)
	if (locale === "ru") return ru_context_menu_copy_text(inputs)
	if (locale === "es") return es_context_menu_copy_text(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_copy_text(inputs)
	if (locale === "ja") return ja_context_menu_copy_text(inputs)
	if (locale === "hi") return hi_context_menu_copy_text(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_copy_text(inputs)
	return en_context_menu_copy_text(inputs)
});